/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getQuotes.defs.js'
export * as $defs from './getQuotes.defs.js'
